////////LIBRARY/////////
import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { map, isUndefined, isEqual, replace, isNull, forEach, cloneDeep } from 'lodash'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
///////COMPONENTS///////
import theme from '../../../theme/theme'
import Button from '../../../components/Ui/Buttons'
import Modals from '../../../components/Modals'
import { InputWrapper, InputLogin, ErrorInputMsg, LabelText, TextModal, ButtonWrapper } from '../../../theme/GlobalCss'
import StringFormatter from '../../../helpers/StringFormatter'
import { itemCatalogActionCreators } from '../../../store/actions'
import { uriList } from '../../../routings/settings/RouteList'
/////////ASSETS/////////
import Validation from '../../../assets/icones/global/check.svg'
import Cancel from '../../../assets/icones/global/close-white.svg'
import noImage from '../../../assets/icones/global/no-picture.svg'
import Printer from '../../../assets/icones/global/printer-white.svg'

/////////STYLED/////////
const TextDescription = styled(TextModal)`
	text-align: center;
	padding-bottom: 0px;
`
const ItemWrapper = styled.div`
	text-align: center;
`
const AccessoryWrapper = styled.div``

const TermOfUseWrapper = styled.div``

const WrapperRadio = styled.div`
	width: 100%;
	height: 95%;
	display: flex;
	align-items: center;
	justify-content: space-around;
`
const RadioInputLabel = styled.label`
	vertical-align: baseline;
	font-size: ${(props) => props.theme.font.fm};
`
const RadioInputPerimeter = styled.input`
	border: none;
	width: auto;
	height: auto;
	display: inline;
	vertical-align: baseline;
	font-size: ${(props) => props.theme.font.fm};
	color: ${(props) => props.theme.colors.primary};
`
const ValueWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 15px;
`
const ValueBorder = styled.div`
	height: 45px;
	width: ${(props) => (props.width ? props.width : '260px')};
	border: 2px solid ${(props) => props.borderColor};
	display: flex;
	align-items: center;
	justify-content: center;
`
const AccessoryImageWrapper = styled.label`
	position: relative;
	display: flex;
	max-width: 146px;
	max-height: 146px;
	cursor: pointer;
`
const AccessoryImage = styled.img`
	display: flex;
	max-width: 45px;
	max-height: 45px;
	border: ${(props) => (props.selected ? `2px solid ${props.theme.colors.primary}` : 'none')};
	box-sizing: border-box;
`
const CheckboxElement = styled.input`
	position: absolute;
	top: 14px;
	left: 67px;
`
const AccessoriesText = styled.p`
	margin: 0;
	text-align: center;
	color: ${(props) => (props.colored ? props.colored : props.theme.colors.black)};
`

const WrapperSection = styled.div`
	display: grid;
	grid-template-columns: minmax(0px, 160px) minmax(0px, 160px);
	grid-column-gap: 32px;
	grid-row-gap: 26px;
	max-height: 250px;
	overflow-y: auto;
`
const WrapperAccessory = styled.div`
    width 200px;
    height:80px;
    max-height:200px;
    overflow-y:auto:
    display flex;
    flex-direction:column;
`
const WrapperTopAccessory = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
`
const WrapperInput = styled.div`
	width: 50%;
`
const WrapperPicture = styled.div`
	width: 50%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
`
const WrapperTextAcc = styled.div``

const InputLoginCustom = styled(InputLogin)`
	width: 150px;
	border: 1px solid ${(props) => props.theme.colors.cancel};
	margin-right: 15px;
	margin-top: 5px;
`
const InputLabelWrapper = styled.div`
	max-width: 100%;
	display: flex;
	justify-content: ${(props) => (props.flexStart ? 'flex-start' : 'space-around')};
	margin-bottom: 15px;
	margin-top: ${(props) => props.modalTitle === 'contract' && props.theme.margin.mt};
`
const Split = styled.div`
	border: 1px solid ${theme.colors.black};
	margin-bottom: 15px;
	opacity: 0.33;
`
const BottomWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(5, minmax(min-content, max-content));
	grid-gap: 30px;
	grid-template-rows: 90px;
	align-items: center;
	margin-top: 5px;
`
const BottomLeftWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: repeat 1fr;
	justify-content: center;
	margin-left: 30%;
`
const BottomMiddleWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: repeat(2, 1fr);
	grid-gap: 10px;
`
const BottomRightWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: repeat(2, 1fr);
	grid-gap: 10px;
`
const PrintTicketWrapper = styled(Link)`
	height: 85px;
	width: 85px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${(props) => props.theme.colors.primary};
	cursor: pointer;
	border-radius: 3px;
	text-decoration: none;
	flex-direction: column;
	padding: 5px 0;
`
const PrintTicketImage = styled.img`
	max-width: 38px;
	max-height: 38px;
`
const InputGeneratedCode = styled(InputLogin)`
	&::placeholder {
		text-align: center;
	}
`
/////////STYLED/////////

const ModalSaleByCode = (props) => {
	// Modal Text
	const [title, setTitle] = useState('')
	const [description, setDescription] = useState('')

	// Values
	const [depositPrice, setDepositPrice] = useState(null)
	const [accessoryPrice, setAccessoryPrice] = useState(null)
	const [standardPrice, setStandardPrice] = useState('')
	const [ttcValue, setTtcValue] = useState('')

	// Radio button day
	const [days, setDays] = useState(1)
	const durationDays = ['1', '2', '3']
	const [durationDay, setDurationDay] = useState('1')

	// Accessory
	const [checkBoxValue, setCheckBoxValue] = useState(null)
	const [accessory, setAccessory] = useState()
	const [accessoryKey, setAccessoryKey] = useState(null)
	const [checked, setChecked] = useState(false)
	//const [accessories, setAccessories] = useState()  DATASET
	//const [idBoxTest, setIdBoxTest] = useState(null)  DATASET
	// Modal information
	const [showModalInformation, setShowModalInformation] = useState(false)

	// Generate code modal
	const [showGenerateModal, setShowGenerateModal] = useState(false)
	const [unActiveButton, setUnActiveButton] = useState(true)
	const [guestPhone, setGuestPhone] = useState('')
	const [guestMail, setGuestMail] = useState('')
	const { register, handleSubmit, watch, errors } = useForm()

	const { user, translations, itemsCodeGenerate } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			itemsCodeGenerate: state.itemCatalog.itemGenerateCode.item,
		}),
		shallowEqual
	)

	const actionsItemCatalog = bindActionCreators(itemCatalogActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleChangeRadio = (e) => {
		setDurationDay(e.currentTarget.value)
	}

	// Determine if radio is checked or unchecked (accessory)
	const checkboxChangeHandler = (evt) => {
		//setIdBoxTest(evt.target.id)
		setAccessoryKey(evt.target.id)
		setCheckBoxValue(evt.target.value)
		setChecked(!checked)
	}

	const handleGuestInformationModal = () => {
		setShowModalInformation(true)
		props.closeModal()
	}

	const handleCloseInformationModal = () => {
		setShowModalInformation(false)
	}

	const handleGetGuestPhone = (e) => {
		setGuestPhone(e.target.value)
	}

	const handleGetGuestMail = (e) => {
		setGuestMail(e.target.value)
	}

	const handleGenerateCodeModal = () => {
		setShowGenerateModal(false)
		// we pass a flag through the store to refresh call when we close this modal
		// this is necessary to update item stock on item catalog
		actionsItemCatalog.setIsClosedModal()
	}

	// Get data from information modal
	const handleGenerateCode = (dataRow) => {
		let itemKiosk = [
			{
				id: props.item.item.id,
				idCurrentClassicPromotionLineInProgres: null,
			},
		]

		if (!isNull(checkBoxValue)) {
			itemKiosk.push({
				id: parseInt(checkBoxValue, 10),
				idCurrentClassicPromotionLineInProgres: null,
			})
		}

		let dataToSend = {
			idUserConnected: user.identity.id,
			clientFirstname: dataRow.firstName,
			clientLastname: dataRow.lastName,
			clientEmail: dataRow.email,
			customerId: dataRow.customerNumber || null,
			companyName: dataRow.companyName || null,
			erpOrderId: dataRow.commandRef || null,
			erpBlId: dataRow.bl || null,
			customerMobileNumber: dataRow.mobilePhone || null,
			durationDays: parseInt(durationDay, 10),
			withDeposit: props.target === 'sale' ? true : false,
			itemsKiosk: itemKiosk,
		}
		setShowModalInformation((prevState) => !prevState)
		actionsItemCatalog.postCreateCode(dataToSend)
	}

	const handleSendCode = (target) => {
		if (target === 'phone') {
			let bodyMsg = {
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				phoneNumber: guestPhone,
			}
			actionsItemCatalog.postSendCode(itemsCodeGenerate.id, 'sms', null, null, bodyMsg)
			setShowGenerateModal(false)
			actionsItemCatalog.setIsToUpdate()
		} else if (target === 'guestMail') {
			actionsItemCatalog.postSendCode(itemsCodeGenerate.id, 'mail', 'email', guestMail)
			setShowGenerateModal(false)
			actionsItemCatalog.setIsToUpdate()
		}
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (!isUndefined(itemsCodeGenerate)) {
			setShowGenerateModal(true)
		}
	}, [itemsCodeGenerate])

	useEffect(() => {
		setShowGenerateModal(false)
	}, [])

	// To set modal title according target
	useEffect(() => {
		switch (props.target) {
			case 'sale':
				setTitle(translations['common__text__sale'])
				setDescription(
					StringFormatter.ResponseMessageParser(translations['modal__generateCode__description'], [translations['common__text__sale']])
				)
				break
			case 'exchange':
				setTitle(translations['common__text__exchange'])
				setDescription(
					StringFormatter.ResponseMessageParser(translations['modal__generateCode__description'], [translations['common__text__exchange']])
				)
				break
			default:
				break
		}
	}, [props.target])

	// Set prices in case if we dont have accessory
	useEffect(() => {
		if (!isUndefined(props.item.item)) {
			let sum = 0
			if (props.target === 'sale') {
				setDepositPrice(
					!isNull(props.item?.item?.depositPrice)
						? `${replace(props.item?.item?.depositPrice.toFixed(2), '.', ',')}${props.item.item?.currency?.symbol}`
						: null
				)
				sum = !isNull(props.item?.item?.depositPrice)
					? props.item?.item?.standardPrice + props.item?.item?.depositPrice
					: props.item?.item?.standardPrice
			} else {
				sum = props.item?.item?.standardPrice
			}
			setStandardPrice(`${replace(props.item?.item?.standardPrice.toFixed(2), '.', ',')}${props.item.item?.currency?.symbol}`)

			setTtcValue(`${replace(sum.toFixed(2), '.', ',')}${props.item.item?.currency?.symbol}`)
		}
	}, [props.item.item])

	// to determine if we ha an accessory checked and set accessory
	useEffect(() => {
		let accessoryPriceCp = cloneDeep(accessoryPrice)
		if (checked) {
			map(props.item.item.accessories, (elem, _key) => {
				if (elem.id == accessoryKey) {
					accessoryPriceCp = elem?.standardPrice
				}
			})
			setAccessoryPrice(`${replace(accessoryPriceCp.toFixed(2), '.', ',')}${props.item.item?.currency?.symbol}`)
		} else {
			setAccessoryPrice(null)
		}
	}, [checked])
	// to set new ttcValue if we have  accessory
	useEffect(() => {
		let sum = ''
		if (!isNull(accessoryPrice) && !isUndefined(accessoryPrice)) {
			const stdPriceCp = cloneDeep(standardPrice)
			const accPriceCp = cloneDeep(accessoryPrice)
			const depPriceCp = cloneDeep(depositPrice)
			// we need to parseFloat state because when we get them they are type string
			// we test if we come from sale or exchange if exchange we dont need to add deposit price to ttcValue
			if (props.target === 'sale') {
				if (checked)
					sum =
						parseFloat(stdPriceCp.replace(',', '.')) + parseFloat(accPriceCp.replace(',', '.')) + parseFloat(depPriceCp.replace(',', '.'))
				else sum = parseFloat(stdPriceCp.replace(',', '.')) + parseFloat(depPriceCp.replace(',', '.'))
			} else {
				if (checked) sum = parseFloat(stdPriceCp.replace(',', '.')) + parseFloat(accPriceCp.replace(',', '.'))
				else sum = parseFloat(stdPriceCp.replace(',', '.'))
			}
			setTtcValue(`${replace(sum.toFixed(2), '.', ',')}${props.item.item?.currency?.symbol} `)
		}
	}, [accessoryPrice, checked])

	// set accessories ans set key to test on jsx if whe have to checked radio
	useEffect(() => {
		if (!isUndefined(props.item.item)) {
			setAccessory(props.item.item.accessories)
			forEach(props.item.item.accessories, (_v, k) => {
				setAccessoryKey(k)
			})
		}
	}, [props.item.item])

	// Reset state when we close modale
	useEffect(() => {
		if (!props.showModal) {
			setAccessoryKey(null)
			setCheckBoxValue(null)
			setChecked(false)
			setAccessoryPrice(null)
			setDepositPrice(null)
			setTtcValue('')
			setDurationDay('1')
			setUnActiveButton(true)
			setGuestMail('')
		}
	}, [props.showModal])

	// To change state of phone button
	useEffect(() => {
		if (guestPhone.length > 0 && itemsCodeGenerate?.numberSMSAvailable !== 0) {
			setUnActiveButton(false)
		} else if (guestPhone.length > 0 && itemsCodeGenerate?.optionsSMS) setUnActiveButton(false)
	}, [guestPhone])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			{/* MODAL CODE GENERATION*/}
			<Modals
				title={`${translations['modal__generateCode__title']} ${title} `}
				closeModalHandler={props.closeModal}
				showModal={props.showModal}
				icon={true}
			>
				<TextDescription>{description}</TextDescription>
				<ItemWrapper>
					<span style={{ color: theme.colors.primary }}>{props.item.item?.brand}</span> <span>-</span> <span>{props.item.item?.label}</span>
				</ItemWrapper>

				<TextModal color={theme.colors.primary}>{translations['modal__generateCode__selectAccessory']} :</TextModal>
				<AccessoryWrapper>
					{isEqual(props.item.item?.accessories, []) ? (
						<TextModal align="center" color={theme.colors.error}>
							{translations['modal__generateCode__noAccessoryAvailable']}
						</TextModal>
					) : (
						<WrapperSection>
							{' '}
							{map(props.item.item?.accessories, (item, _id) => (
								<WrapperAccessory>
									<WrapperTopAccessory>
										<WrapperInput>
											<AccessoryImageWrapper id={item.id}>
												<CheckboxElement
													type="checkbox"
													id={item.id}
													value={item.id}
													//checked={item.id == idBoxTest}
													checked={item.id == accessoryKey && checked}
													onChange={checkboxChangeHandler}
												/>
											</AccessoryImageWrapper>
										</WrapperInput>
										<WrapperPicture>
											<AccessoryImage selected={item.checked} src={item.picture ? `/${item.picture}` : noImage} />
										</WrapperPicture>
									</WrapperTopAccessory>
									<WrapperTextAcc>
										{' '}
										<AccessoriesText>{item.label}</AccessoriesText>
									</WrapperTextAcc>
								</WrapperAccessory>
							))}
						</WrapperSection>
					)}
				</AccessoryWrapper>
				<TermOfUseWrapper>
					<TextModal color={theme.colors.primary}>{translations['modal__admin__renewCode__expirationTime']} :</TextModal>
					<WrapperRadio>
						{map(durationDays, (v) => (
							<RadioInputLabel>
								<RadioInputPerimeter
									type="radio"
									value={v}
									name="durationDay"
									onChange={handleChangeRadio}
									checked={durationDay === v}
									onClick={() => setDays(v)}
								/>
								{v === '1'
									? translations['common__text__1day']
									: v === '2'
									? translations['common__text__2days']
									: translations['common__text__3days']}
							</RadioInputLabel>
						))}
					</WrapperRadio>
				</TermOfUseWrapper>
				<TextModal align={'center'} underline={true}>
					{translations['modal__generateCode__totalAmount']} :
				</TextModal>
				<ValueWrapper>
					<ValueBorder borderColor={theme.colors.validation}>
						<TextModal color={theme.colors.validation}>
							{!isNull(depositPrice) && !isNull(accessoryPrice)
								? `${standardPrice} + ${depositPrice} ${checked && '+ ' + accessoryPrice} = ${ttcValue} `
								: isNull(depositPrice) && !isNull(accessoryPrice)
								? `${standardPrice} ${checked && '+ ' + accessoryPrice} = ${ttcValue} `
								: !isNull(depositPrice) && isNull(accessoryPrice)
								? `${standardPrice} + ${depositPrice}  = ${ttcValue} `
								: `${ttcValue} `}
						</TextModal>
						<sup
							style={{
								fontSize: theme.font.fxs,
								color: theme.colors.validation,
								height: '100px',
								lineHeight: '90px',
								marginLeft: '2px',
							}}
						>
							{translations['common__text__TTC']}
						</sup>
					</ValueBorder>
				</ValueWrapper>

				<ButtonWrapper>
					<Button
						actionHandler={props.closeModal}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleGuestInformationModal()}
						text={translations['modal__generateCode__button_validAndGenerate']}
						bgColor={theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>

			{/* MODAL GUEST INFORMATION*/}

			<Modals
				title={translations['page__transactionsHistory__admin__consignmentContract__modalInformation_title']}
				closeModalHandler={handleCloseInformationModal}
				showModal={showModalInformation}
				icon={true}
			>
				<form onSubmit={handleSubmit(handleGenerateCode)}>
					<InputLabelWrapper>
						<InputWrapper>
							<LabelText>{translations['modal__customerInfo__form_name']}* :</LabelText>
							<InputLoginCustom
								name="lastName"
								type="text"
								placeholder={translations['modal__customerInfo__form_name']}
								ref={register({
									required: {
										value: true,
										message: translations['common__text__requiredField'],
									},
								})}
							/>
							{errors.lastName && <ErrorInputMsg>{errors.lastName.message}</ErrorInputMsg>}
						</InputWrapper>
						<InputWrapper>
							<LabelText>{translations['modal__customerInfo__form_firstname']}* :</LabelText>
							<InputLoginCustom
								name="firstName"
								type="text"
								placeholder={translations['modal__customerInfo__form_firstname']}
								ref={register({
									required: {
										value: true,
										message: translations['common__text__requiredField'],
									},
								})}
							/>
							{errors.firstName && <ErrorInputMsg>{errors.firstName.message}</ErrorInputMsg>}
						</InputWrapper>
						<InputWrapper>
							<LabelText>{translations['modal__customerInfo__form_email']}* :</LabelText>
							<InputLoginCustom
								name="email"
								type="text"
								placeholder={translations['modal__customerInfo__form_email']}
								ref={register({
									required: {
										value: true,
										message: translations['common__text__requiredField'],
									},
									pattern: {
										value: RegExp(
											/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
										),
										message: translations['common__text__invalidEmail'],
									},
								})}
							/>
							{errors.email && <ErrorInputMsg>{errors.email.message}</ErrorInputMsg>}
						</InputWrapper>
					</InputLabelWrapper>
					<Split />
					<span style={{ fontWeight: 900 }}>{translations['modal__customerInfo__additionnal_info_title']} : </span>
					<div>
						<InputLabelWrapper style={{ marginTop: 15 }}>
							<InputWrapper>
								<LabelText>{translations['modal__customerInfo__additionnal_info_customerNumber']} :</LabelText>
								<InputLoginCustom
									name="customerNumber"
									type="text"
									placeholder={translations['modal__customerInfo__additionnal_info_customerNumber']}
									ref={register({})}
								/>
							</InputWrapper>
							<InputWrapper>
								<LabelText>{translations['modal__customerInfo__additionnal_info_companyName']} :</LabelText>
								<InputLoginCustom
									name="companyName"
									type="text"
									placeholder={translations['modal__customerInfo__additionnal_info_companyName']}
									ref={register({})}
								/>
							</InputWrapper>
							<InputWrapper>
								<LabelText>{translations['modal__customerInfo__additionnal_info_mobilePhone']} :</LabelText>
								<InputLoginCustom
									name="mobilePhone"
									type="text"
									placeholder={translations['modal__customerInfo__additionnal_info_mobilePhone']}
									ref={register({})}
								/>
							</InputWrapper>
						</InputLabelWrapper>
					</div>
					<div>
						<InputLabelWrapper flexStart={true}>
							<InputWrapper>
								<LabelText>{translations['modal__customerInfo__additionnal_info_ERP_command_ref']} :</LabelText>
								<InputLoginCustom
									name="commandRef"
									type="text"
									placeholder={translations['modal__customerInfo__additionnal_info_ERP_command_ref']}
									ref={register({})}
								/>
							</InputWrapper>
							<InputWrapper>
								<LabelText>{translations['modal__customerInfo__additionnal_info_ERP_BL']} :</LabelText>
								<InputLoginCustom
									name="bl"
									type="text"
									placeholder={translations['modal__customerInfo__additionnal_info_ERP_BL']}
									ref={register({})}
								/>
							</InputWrapper>
						</InputLabelWrapper>
					</div>
					<ButtonWrapper>
						<Button
							actionHandler={handleCloseInformationModal}
							text={translations['common__text__cancel']}
							bgColor={theme.colors.error}
							margin="true"
							img={Cancel}
							type="submit"
						/>
						<Button
							//actionHandler={() => {handleGuestTicketAsk() }}
							text={translations['common__text__save']}
							bgColor={theme.colors.validation}
							img={Validation}
							width={250}
						/>
					</ButtonWrapper>
				</form>
			</Modals>

			{/*MODAL PRINT / SEND CODE*/}

			<Modals
				closeModalHandler={handleGenerateCodeModal}
				//showModal={true}
				showModal={showGenerateModal}
				title={translations['modal__generatedCode__title']}
				icon={true}
			>
				<TextModal style={{ textAlign: 'center' }}>
					{`${StringFormatter.ResponseMessageParser(translations['modal__generatedCode__description'], [title])} `}
					<span style={{ color: theme.colors.primary }}> {itemsCodeGenerate?.itemsKiosk[0]?.itemBrand?.label}</span>
					<span> - </span>
					<span>{itemsCodeGenerate?.itemsKiosk[0].label}</span>
				</TextModal>
				<ValueWrapper>
					<ValueBorder
						width={'100%'}
						style={{ fontSize: theme.font.fxxl, color: theme.colors.black, fontWeight: theme.weight.bold }}
						borderColor={theme.colors.primary}
					>
						{itemsCodeGenerate?.generatedCode}
					</ValueBorder>
				</ValueWrapper>
				<BottomWrapper>
					<BottomLeftWrapper>
						<PrintTicketWrapper to={`${uriList.ticketCodes}/${itemsCodeGenerate?.id}`} target={'_blank'}>
							<PrintTicketImage src={Printer} />
							<TextModal style={{ textAlign: 'center', color: theme.colors.white, height: '36px' }} padding={'0'}>
								{translations['modal__admin__reprintCode__button_printTicket']}
							</TextModal>
						</PrintTicketWrapper>
					</BottomLeftWrapper>
					<div style={{ fontWeight: theme.weight.bold, textAlign: 'center', fontSize: theme.font.fxl, paddingLeft: '8px' }}>
						{translations['modal__admin__reprintCode__text_or']}
					</div>
					<BottomMiddleWrapper>
						<InputGeneratedCode
							name="phone"
							type="text"
							//onFocus={handlerFocus}
							placeholder={translations['modal__admin__reprintCode__telNumber_prefilled']}
							border={theme.colors.grey}
							onChange={handleGetGuestPhone}
						/>

						<Button
							text={
								itemsCodeGenerate?.numberSMSAvailable
									? `${translations['modal__admin__reprintCode__button_sendSMS_numberLeft_start']} ${
											isUndefined(itemsCodeGenerate?.numberSMSAvailable) ? '0' : `(${itemsCodeGenerate?.numberSMSAvailable})`
									  } ${translations['modal__admin__reprintCode__button_sendSMS_numberLeft_end']} `
									: translations['modal__admin__reprintCode__button_sendSMS_numberLeft_start']
							}
							bgColor={theme.colors.validation}
							height={32}
							width={208}
							radius={'3px'}
							actionHandler={() => handleSendCode('phone')}
							disabled={unActiveButton}
						/>
					</BottomMiddleWrapper>
					<div style={{ fontWeight: theme.weight.bold, textAlign: 'center', fontSize: theme.font.fxl }}>
						{translations['modal__admin__reprintCode__text_or']}
					</div>
					<BottomRightWrapper>
						<InputGeneratedCode
							name="guestEmail"
							type="text"
							width={208}
							//onFocus={handlerFocus}
							placeholder={translations['modal__customerInfo__additionnal_info_customer_email']}
							border={theme.colors.grey}
							ref={register({
								pattern: {
									value: RegExp(
										/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
									),
									message: translations['common__text__invalidEmail'],
								},
							})}
							onChange={handleGetGuestMail}
						/>
						{errors.guestEmail && <ErrorInputMsg>{errors.guestEmail.message}</ErrorInputMsg>}
						<Button
							text={translations['modal__customerInfo__additionnal_info_sendEmail']}
							bgColor={theme.colors.validation}
							height={32}
							width={208}
							radius={'3px'}
							actionHandler={() => handleSendCode('guestMail')}
							disabled={/*!isUndefined(guestMail) && */ !guestMail.length > 0}
						/>
					</BottomRightWrapper>
				</BottomWrapper>
			</Modals>
		</>
	)
}

export default ModalSaleByCode
